import * as type from './type';
export default {
    [type.SET_CART_TOTAL_NUM](state, cartTotalNum) {
        state.cartTotalNum = cartTotalNum;
    }
}


// WEBPACK FOOTER //
// ./src/store/cart/mutations.js